// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"c342ef05","639":"8e64deff"}[chunkId] + ".chunk.js";
};